import { Label } from "@/app/components/shadcn/label";
import { Switch } from "@/app/components/shadcn/switch";
import { FilterHeaderItem } from "@/app/lib/features/filters/filters.types";
import useFilters from "@/app/lib/features/filters/filters.hook";

interface FilterHeaderSectionProps {
  items: FilterHeaderItem[];
}

const FilterHeaderSection = ({ items }: FilterHeaderSectionProps) => {
  const { toggleBoolean, selected } = useFilters();

  if (!items.length) return null;

  return (
    <div className="border-b pb-3 mb-2 space-y-2 pt-2">
      {items.map((item) => (
        <div key={item.key} className="flex items-center justify-between p-2">
          <Label
            htmlFor={`header-${item.key}`}
            className="text-sm font-medium cursor-pointer"
          >
            {item.title}
          </Label>
          <Switch
            id={`header-${item.key}`}
            checked={selected[item.key] as boolean}
            onCheckedChange={() => toggleBoolean(item.key)}
          />
        </div>
      ))}
    </div>
  );
};

export default FilterHeaderSection;
